import { useContext } from 'react';
import AppTheme from '../contexts/AppTheme';

const useAppTheme = () => {
  return useContext(AppTheme);
};

export default useAppTheme;
